import { useState, useEffect } from "react";
import "./createProvider.css";
import "./CreateProvider.responsive.css";
import SideMenu from "../../features/sideMenu/SideMenu";
import CustomButton from "../../ui/button/Button";
import Select from "react-select";
import CustomSelect from "../../ui/select/Select";
import {
  fieldsAddProviderBank,
  fieldsAddProviderContact,
  fieldsAddProviderData,
  fieldsAddProvider,
} from "../../constants/addUser.constats";
import MapModal from "../../ui/map/MapaModal";
import { SpecialtiesSelector } from "../functions/Providers";
import useConfirmDialog from "../../features/modal/ConfirmDialog";
import { useNavigate } from "react-router-dom";
import { createProvider } from "../functions/Functions";
import { itemsProviders } from "../../constants/providers";

const CreateProvider = ({ states, specialties, status, API_URL, user }) => {
  const [payload, setPayload] = useState(null);
  const [isMapModalOpen, setIsMapModalOpen] = useState(false);
  const showDialog = useConfirmDialog();
  const navigate = useNavigate();

  useEffect(() => {
    if (status.length > 0) {
      setPayload({
        razonSocial: null,
        rfc: null,
        direccionFiscal: "",
        latitude: null,
        longitude: null,
        fechaInscripcion: new Date().toISOString().slice(0, 10),
        estatus:
          status.find((statu) => statu.nombre?.toLowerCase() === "inactivo")
            ?.id || null,
        calificacion: null,
        comentarios: null,
        cobertura: [],
        especialidades: [],
        contacto: {
          nombre: null,
          apellido: null,
          telefono: null,
          email: null,
        },
        datosBancarios: {
          banco: null,
          numeroCuenta: null,
          clabeInterbancaria: null,
          sucursal: null,
        },
      });
    }
  }, [status]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setPayload((prev) => ({ ...prev, [name]: value }));
  };

  const handleLocationSelect = (location) => {
    setPayload((prev) => ({
      ...prev,
      direccionFiscal: location.address,
      latitude: location.lat,
      longitude: location.lng,
    }));
  };

  const handleMultiSelectChange = (field, selectedOptions) => {
    const selectedValues = selectedOptions
      ? selectedOptions.map((option) => option.value)
      : [];
    setPayload((prev) => ({ ...prev, [field]: selectedValues }));
  };

  const addProvider = () => (
    <div className="form-container">
      <form>
        <div>
          <h1>Información general:</h1>
          <div className="row two-column-section">
            {fieldsAddProvider?.map((field) =>
              field.name === "direccionFiscal" ? (
                <>
                  <div className="form-row full-width" key={field.name}>
                    <div className="d-flex flex-column">
                      <label className="form-label ">{field.label}:</label>
                      <input
                        className="form-input"
                        type="text"
                        name="direccionFiscal"
                        value={payload.direccionFiscal}
                        readOnly
                        placeholder="Selecciona una dirección"
                        onClick={(e) => {
                          e.target.blur();
                          setTimeout(() => setIsMapModalOpen(true), 0);
                        }}
                      />
                    </div>
                  </div>

                  <div className="form-row" key="latitud">
                    <div className="d-flex flex-column">
                      <label className="form-label">Latitud:</label>
                      <input
                        className="form-input"
                        type="text"
                        name="latitude"
                        value={payload.latitude || ""}
                        readOnly
                        placeholder="Latitud"
                      />
                    </div>
                  </div>

                  <div className="form-row" key="longitud">
                    <div className="d-flex flex-column">
                      <label className="form-label">Longitud:</label>
                      <input
                        className="form-input"
                        type="text"
                        name="longitude"
                        value={payload.longitude || ""}
                        readOnly
                        placeholder="Longitud"
                      />
                    </div>
                  </div>

                  {isMapModalOpen && (
                    <div className="map-floating-modal">
                      <MapModal
                        key={isMapModalOpen ? "open" : "closed"}
                        onClose={() => setIsMapModalOpen(false)}
                        onSelectLocation={handleLocationSelect}
                        initialLocation={{
                          lat: payload.latitud || 19.4326,
                          lng: payload.longitud || -99.1332,
                          address: payload.direccionFiscal,
                        }}
                      />
                    </div>
                  )}
                </>
              ) : (
                <div className="form-row" key={field.name}>
                  <div className="d-flex flex-column">
                    <label className="form-label">{field.label}:</label>
                    <input
                      className="form-input"
                      type="text"
                      name={field.name}
                      value={payload[field.name] || ""}
                      onChange={handleChange}
                      placeholder={`Ingresa ${
                        field.label === "RFC"
                          ? "RFC"
                          : field.label.toLowerCase()
                      }`}
                    />
                  </div>
                </div>
              )
            )}
          </div>
        </div>
        <div>
          <div className="row two-column-section">
            {fieldsAddProviderData?.map((field) => (
              <div className="form-row" key={field.name}>
                <div className="d-flex flex-column">
                  <label className="form-label">
                    {field.name === "lenguaje" ? "Idioma" : field.label}:
                  </label>
                  {field.name === "estatus" ? (
                    <CustomSelect
                      options={status.map((statu) => ({
                        value: statu.id,
                        name: statu.nombre,
                      }))}
                      value={payload.estatus || ""}
                      name={field.name}
                      isDisabled={true}
                      onChange={() => {}}
                      width={
                        window.innerWidth <= 480
                          ? "auto" // mobile
                          : window.innerWidth <= 1024
                          ? "250px" // tablet
                          : "500px" // desktop
                      }
                      height={"39px"}
                      textAlign={"left"}
                      heightOption={"100px"}
                      topOption={"-50px"}
                      color={"#6c757d"}
                      className={"form-input"}
                      fontSize={"14px"}
                      fontWeight={600}
                      paddingTop={"8px"}
                      placeholder="Seleccione un estatus"
                      marginBottom={"6px"}
                    />
                  ) : field.name === "cobertura" ? (
                    <div className="cpv-cobertura">
                      <Select
                        options={states.map((state) => ({
                          value: state.id,
                          label: state.nombreEstado,
                        }))}
                        isMulti
                        value={states
                          .filter((state) =>
                            payload.cobertura.includes(state.id)
                          )
                          .map((state) => ({
                            value: state.id,
                            label: state.nombreEstado,
                          }))}
                        onChange={(selectedOptions) =>
                          handleMultiSelectChange("cobertura", selectedOptions)
                        }
                        placeholder="Selecciona cobertura"
                        classNamePrefix="react-select"
                        styles={{
                          control: (provided, state) => ({
                            ...provided,
                            minHeight: "40px",
                            height: "auto",
                            backgroundColor: "#fff",
                            borderColor: state.isFocused ? "#62C776" : "#ccc",
                            boxShadow: state.isFocused
                              ? "0 0 3px #62C776"
                              : "none",
                          }),
                          valueContainer: (provided) => ({
                            ...provided,
                            display: "flex",
                            flexWrap: "wrap",
                            overflowY: "auto",
                            maxHeight: "150px",
                          }),
                          menu: (provided) => ({
                            ...provided,
                            zIndex: 9999,
                            maxHeight: "200px",
                            overflowY: "auto",
                            textAlign: "left",
                          }),
                          menuList: (provided) => ({
                            ...provided,
                            maxHeight: "200px",
                            overflowY: "auto",
                          }),
                          option: (provided, state) => ({
                            ...provided,
                            color: "#000",
                            backgroundColor: state.isSelected
                              ? "#e0e0e0"
                              : "white",
                            "&:hover": {
                              backgroundColor: "#f0f0f0",
                            },
                          }),
                          multiValue: (provided) => ({
                            ...provided,
                            backgroundColor: "#62C776",
                            color: "#fff",
                          }),
                          multiValueLabel: (provided) => ({
                            ...provided,
                            color: "#fff",
                          }),
                          multiValueRemove: (provided) => ({
                            ...provided,
                            color: "#fff",
                            ":hover": {
                              backgroundColor: "#ff6b6b",
                              color: "#fff",
                            },
                          }),
                        }}
                      />
                    </div>
                  ) : field.name === "especialidades" ? (
                    <SpecialtiesSelector
                      specialties={specialties}
                      selectedSpecialties={payload.especialidades || []}
                      onChange={(specialties) =>
                        setPayload((prev) => ({
                          ...prev,
                          especialidades: specialties,
                        }))
                      }
                    />
                  ) : field.name === "comentarios" ? (
                    <input
                      className="form-input"
                      readOnly
                      type="text"
                      name={field.name}
                      value={payload[field.name] || ""}
                      onChange={handleChange}
                      placeholder={` `}
                    />
                  ) : (
                    <input
                      className="form-input"
                      type="text"
                      name={field.name}
                      value={payload[field.name] || ""}
                      onChange={handleChange}
                      placeholder={`Ingresa ${field.label.toLowerCase()}`}
                    />
                  )}
                </div>
              </div>
            ))}
          </div>
        </div>
        <div>
          <h1>Contacto Información:</h1>
          <div className="row two-column-section">
            {fieldsAddProviderContact?.map((field) => (
              <div className="form-row" key={field.name}>
                <div className="d-flex flex-column">
                  <label className="form-label">
                    {field.name === "lenguaje" ? "Idioma" : field.label}:
                  </label>
                  <input
                    className="form-input"
                    type="text"
                    name={field.name}
                    value={payload[field.name] || ""}
                    onChange={handleChange}
                    placeholder={`Ingresa ${field.label.toLowerCase()}`}
                  />
                </div>
              </div>
            ))}
          </div>
        </div>
        <div>
          <h1>Datos Bancarios:</h1>
          <div className="row two-column-section">
            {fieldsAddProviderBank?.map((field) => (
              <div className="form-row" key={field.name}>
                <div className="d-flex flex-column">
                  <label className="form-label">
                    {field.name === "lenguaje" ? "Idioma" : field.label}:
                  </label>
                  <input
                    className="form-input"
                    type="text"
                    name={field.name}
                    value={payload[field.name] || ""}
                    onChange={handleChange}
                    placeholder={`Ingresa ${field.label.toLowerCase()}`}
                  />
                </div>
              </div>
            ))}
          </div>
        </div>
        <div className="button-container">
          <CustomButton
            text={"Guardar"}
            color={"#FFFFFF"}
            border={"none"}
            background={"#62C776"}
            fontStyle={"normal"}
            fontWeight={700}
            fontSize={"14px"}
            width={"75px"}
            height={"28px"}
            type={"button"}
            onClick={() => handleCreateProvider(API_URL, payload)}
          />
        </div>
      </form>
    </div>
  );

  const handleCreateProvider = async () => {
    try {
      const finalPayload = {
        ...payload,
        porDefecto: true,
        cobertura: null,
        coberturaForanea: null,
        direccionBusqueda: payload.direccionFiscal,
        perfilInstalador: {
          id: 2,
          descripcion:
            "Encargado o responsable de los trabajos en sitio, personal autorizado para trabajos de alto riesgo (eléctricos, alturas)",
          documentosNecesarios:
            "FOTO,INE,IMSS,CERTIFICADO_MEDICO,DC3,CREDENCIAL",
          nombre: "LÍDER DE CUADRILLA",
        },
        numGafete: `TEMP_${payload.rfc}`,
        estatusEmpresa: status.find((s) => s.id === payload.estatus),
        estados: states
          .filter((state) => payload.cobertura.includes(state.id))
          .map((state) => ({
            id: state.id,
            nombreEstado: state.nombreEstado,
            pais: null,
            abreviaturas: state.abreviaturas || null,
          })),
        especialidades: specialties
          .filter((esp) => payload.especialidades.includes(esp.id))
          .map((esp) => ({
            id: esp.id,
            nombre: esp.nombre,
            descripcion: esp.descripcion,
            asignada: true,
          })),
        contacto: {
          nombre: payload.nombre,
          apellido: payload.apellidos,
          telefono: payload.telefono,
          email: payload.email,
        },
        datosBancarios: {
          banco: payload.institucionBancaria,
          numeroCuenta: payload.numCuenta,
          clabeInterbancaria: payload.clabeInterbancaria,
          sucursal: payload.sucursal,
        },
        fechaInscripcion: new Date(payload.fechaInscripcion).getTime(),
      };

      await createProvider(API_URL, finalPayload);

      showDialog({
        html: "La empresa fue creada con éxito.",
        icon: "success",
        confirmButtonText: "Aceptar",
        mostrarCancelar: false,
        onConfirm: () => navigate("/proveedores/todos"),
      });
    } catch (error) {
      showDialog({
        html: `Ocurrió un error al crear la empresa.<br>${error.response.data.message}`,
        icon: "error",
        confirmButtonText: "Aceptar",
        mostrarCancelar: false,
      });
    }
  };

  return (
    <div className="cpv-layout" style={{ display: "flex", height: "100%" }}>
      <div className="cpv-sidebar" style={{ width: "12rem" }}>
        <SideMenu items={itemsProviders} />
      </div>
      {payload && (
        <div className="cpv-main createProvider">{addProvider()}</div>
      )}
    </div>
  );
};

export default CreateProvider;
